import React from "react";
import "../assets/css/header.css";
import { StaticImage } from "gatsby-plugin-image";
import { navigate } from "gatsby";
import Button from "./Button";
import { CgMenuLeft } from "react-icons/cg";
import { Link } from "gatsby";

const Header = ({ scrollRef, hideOrderButton }) => {
  // console.log("hideOrderButton", hideOrderButton)
  return (
    <div className="stickyContainer">
      {/* <div className="stickyContainer"> */}
      <nav className="navbar bg-white ">
        <div className="header__section">
          <div
            className="navbar-brand d-flex align-items-center justify-content-between"
            style={{ cursor: "pointer" }}
          >
            <div onClick={() => navigate("/")}>
              <StaticImage
                src="../assets/images/mob-logo1.png"
                className="mlogo"
                objectFit="contain"
                quality={100}
                alt="Stands Logo"
              />
            </div>

            <div
              className="d-flex align-items-center justify-content-between nav__items"
              style={{ marginRight: hideOrderButton ? 0 : "205px" }}
            >
              <div className="nav-item nav-icons-web">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  // target='_blank'
                  // onClick={() => navigate('faq')}
                  to="/"
                >
                  Home
                </Link>
              </div>
              <div className="nav-item nav-icons-web nav__items-faq">
                {/* <a
                  className='nav-link active'
                  aria-current='page'
                  href='https://diagnostics.strandls.com/genomic-wellness/hboc1/allfaqs'
                  target='_blank'
                > */}
                <Link
                  className="nav-link active"
                  aria-current="page"
                  // target='_blank'
                  // onClick={() => navigate('faq')}
                  to="/faq"
                >
                  FAQ
                </Link>
              </div>
              <div className="nav-item nav-icons-web nav__items-faq">
                {/* <a
                  className='nav-link active'
                  aria-current='page'
                  href='https://diagnostics.strandls.com/genomic-wellness/hboc1/allfaqs'
                  target='_blank'
                > */}
                <Link
                  className="nav-link active"
                  aria-current="page"
                  // target='_blank'
                  // onClick={() => navigate('faq')}
                  to="/calculators/breast-cancer-risk-calculator"
                >
                  Risk Calculator
                </Link>
              </div>
              <button
                className="navbar-toggler burger__menu"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                // onClick={() =>  scrollRef.current.scrollIntoView({ behavior: 'smooth' })}
              >
                <CgMenuLeft color="#000" size={35} className="burger__menu" />
              </button>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto  mb-2 mb-lg-0 align-items-center">
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link active" aria-current="page" to="/faq">
                  FAQ
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link active"
                  aria-current="page"
                  to="/calculators/breast-cancer-risk-calculator"
                >
                  Risk Calculator
                </Link>
              </li>
            </ul>

            {/* <ul className="navbar-nav ms-auto  mb-2 mb-lg-0">
           
            </ul> */}
          </div>
        </div>
      </nav>
      {/* </div> */}
    </div>
  );
};

export default Header;
